//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { VueClazyLoad } from 'vue-clazy-load'

export default {
  components: {
    VueClazyLoad
  },
  props: {
    value: {
      required: false,
      default: null
    },
    competition: {
      default: null
    },
    filters: {
      default: null
    }
  }
}
